var map = {
	"./symbol_0.png": "faa2",
	"./symbol_1.png": "586f",
	"./symbol_2.png": "2f35",
	"./symbol_3.png": "84c9",
	"./symbol_4.png": "a1fd",
	"./symbol_5.png": "75a2",
	"./symbol_6.png": "a12a",
	"./symbol_7.png": "d7ab",
	"./symbol_8.png": "adf3",
	"./symbol_9.png": "66ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54e1";